module.exports = __webpack_public_path__ + "img/temp-notes.449b4d69.svg";